import { useSettings } from 'components/SettingsProvider';

export function useLocale() {
  const { utils, settings } = useSettings();

  let locale = '';

  const customLocale = settings.reviews.tweaks.locale;

  if (customLocale) {
    locale = customLocale;
  } else {
    //locale = utils.locale;
    locale = 'en';
  }

  return {
    locale,
  };
}
